import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { DocumentProduct } from '@cas/config/documents';
import { setTechLibProducts } from '@customer/store/slices/filtersSlice';

const useProductOptions = (): DropdownItemProps<DocumentProduct>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(DocumentProduct)
      .map((value: DocumentProduct) => ({
        key: value,
        value,
        stringValue: value,
        label: t(`DocProduct.${value}`),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [t]);
};

export const TechLibraryProductsFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<DocumentProduct>
      filterName="techLibProducts"
      label={label ?? t('Product')}
      action={setTechLibProducts}
      elementRef={elementRef}
      useItemsHook={useProductOptions}
    />
  );
};

export default TechLibraryProductsFilter;
